const Theme = {
  logo_image_url: 'pointeacalliere.png',
  logo_height: 90,

  body_background_color: '#005c33',

  button_color: '#bf3216',
  button_radius: 25,
  button_half_border_color: '#bf3216',

  text_font: `'Jost', sans-serif`,
  title_font: `'Jost', sans-serif`,
}

export default Theme
